<template>
<div class="ql-cue-layer-picker">
    <div class="ql-button-container" v-if="locked || !editable">
        <md-button :style="{backgroundColor: currentLayer.color}" class="ql-cue-layer-picker" >
        </md-button>
    </div>
    <md-menu md-size="4" ref="layerMenu" v-else>
        <md-button md-menu-trigger class="ql-cue-layer-picker" :style="{backgroundColor: currentLayer.color}">
            <md-tooltip md-direction="top">Click to change layer</md-tooltip>
        </md-button>
        <md-menu-content>
            <md-menu-item v-for="layer in layers" :key="layer.id" @selected="selectLayer(layer.id)">
                <span class="ql-cue-layer-picker" :style="style(layer)"></span>
                <span class="ql-cue-layer-picker-option">{{layer.title}}</span>
            </md-menu-item>
        </md-menu-content>
    </md-menu>
</div>
</template>

<script>
const ProjectCuesLayerPicker = {
    name: 'projectCuesLayerPicker',
    props: ['layers', 'currentLayer', 'editable', 'locked'],
    data: function() {
        return {
        };
    },
    computed: {
    },
    methods: {
        style(layer) {
            const val = 'background-color: ' + layer.color + ' !important;';
            return val;
        },
        open() {
            this.$refs.layerMenu.open();
        },
        selectLayer(layer) {
            this.$emit('selectLayer', layer);
        }
    },
    components: {
    }
};

export default ProjectCuesLayerPicker;
</script>

<style>
.ql-button-container {
    position: relative;
}
.ql-cue-layer-picker {
    min-height: 48px; 
    min-width: 48px;
    margin: 0;
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 0;
}
.ql-cue-layer-picker-option {
    margin-left: 48px;
}
</style>


// WEBPACK FOOTER //
// layer-picker.vue?4f407c6f